var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 876,
    height: 774,
    viewBox: "0 0 876 774",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 876,
    height: 774,
    rx: 5,
    fill: "#545456"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 0.895356 6.8801 1.99983 12.9 1.99983H863.1C869.12 1.99983 874 0.895477 874 7.00012V271.332H2V7Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 271.332H874C697.144 349.48 524.264 365.316 459.932 363.466C232.545 370.57 59.8993 305.004 2 271.332Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgField);
export default __webpack_public_path__ + "static/media/field.629a61393cc92d11d3ef197136410429.svg";
export { ForwardRef as ReactComponent };